import { Dialog, Typography } from "@inductiveautomation/ws-components";
import { useTranslation } from "react-i18next";
import { getBillingAddressConfirmationDialogStyles } from "../../_training.styles";
import { BillingAddressForm, CertificationType } from "../../Training.types";
const BillingAddressConfirmationDialog = ({
  translationKeyPrefix,
  isOpen,
  certificationType,
  billingAddressValues,
  validatedAddressValues,
  confirmValidatedAddress,
  onCancel,
}: {
  translationKeyPrefix:
    | "training.actions.purchase_test.dialog.core.steps.credit_card"
    | "training.actions.purchase_test.dialog.gold.steps.credit_card";
  isOpen: boolean;
  certificationType?: CertificationType;
  billingAddressValues?: BillingAddressForm;
  validatedAddressValues?: BillingAddressForm;
  confirmValidatedAddress: () => void;
  onCancel: () => void;
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: translationKeyPrefix,
  });
  const { classes } = getBillingAddressConfirmationDialogStyles();
  return (
    <Dialog
      isStackedDialog
      showCloseButton
      contentArea={
        <div className={classes.container}>
          <div className={classes.addressColumn}>
            <Typography className={classes.addressColumnLabel}>
              {t("dialog.original_address")}
            </Typography>
            <Typography>{billingAddressValues?.streetAddressLine1}</Typography>
            {billingAddressValues?.streetAddressLine2 && (
              <Typography>{billingAddressValues.streetAddressLine2}</Typography>
            )}
            <Typography>
              {billingAddressValues?.city}
              {billingAddressValues?.countryHasState
                ? `, ${billingAddressValues.stateOrProvince}`
                : ""}
            </Typography>

            <Typography>{billingAddressValues?.zipcodeOrPostalCode}</Typography>
            <Typography>{billingAddressValues?.country}</Typography>
          </div>
          <div className={classes.addressColumn}>
            <Typography className={classes.addressColumnLabel}>
              {t("dialog.standardized_address")}
            </Typography>
            <Typography>
              {validatedAddressValues?.streetAddressLine1}
            </Typography>
            {validatedAddressValues?.streetAddressLine2 && (
              <Typography>
                {validatedAddressValues.streetAddressLine2}
              </Typography>
            )}
            <Typography>
              {validatedAddressValues?.city},{" "}
              {validatedAddressValues?.stateOrProvince}
            </Typography>

            <Typography>
              {validatedAddressValues?.zipcodeOrPostalCode}
            </Typography>
            <Typography>{validatedAddressValues?.country}</Typography>
          </div>
        </div>
      }
      headline={t("dialog.headline")}
      supportingText={t("dialog.supporting_text")}
      onClose={onCancel}
      testId={`${certificationType?.toLowerCase()}-billing-address-confirmation-dialog`}
      isOpen={isOpen}
      actions={[
        {
          label: t("dialog.cancel"),
          type: "cancel",
          onClick: onCancel,
        },
        {
          label: t("dialog.confirm_address"),
          type: "submit",
          onClick: confirmValidatedAddress,
        },
      ]}
    />
  );
};

export default BillingAddressConfirmationDialog;
